import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";

const ControlBatchGrid = (props) => {
    const columns = [
        {
            field: "created",
            label: "Datum generování",
            type: ColumnType.DATE,
            width: "30%",
        },
        {
            field: "requestedCount",
            label: "Počet funkcionářů",
            type: ColumnType.TEXT,
            width: "30%",
            filterable: false,
        },
    ];

    return (
        <CommonGrid
            columns={columns}
            sort="created"
            {...props}
        />
    );
};

export default ControlBatchGrid;